import { createAction, props } from '@ngrx/store';

import { DocumentFilterValues } from '@lockton-apps/client-gateway/interfaces';
import { Document, Folder } from '@lockton-apps/shared/interfaces';

export enum PolicyDetailsActionTypes {
  Init = '[PolicyDetails Page] Init',

  Deleted = '[PolicyDetails Page] Deleted',
  Restored = '[PolicyDetails Page] Restored',

  EditPolicyClicked = '[PolicyDetails Page] Edit Policy Clicked',

  DocumentSelected = '[PolicyDetails Page] Document Selected',

  UploadDocumentsClicked = '[PolicyDetails Page] Upload Documents Clicked',
  FilesDropped = '[PolicyDetails Page] Files Dropped',

  ResetFilters = '[PolicyDetails/Page] Reset Filters',

  FolderCreated = '[PolicyDetails Page] Folder Created',
  FolderEditted = '[PolicyDetails Page] Folder Editted',
  FolderDeleted = '[PolicyDetails Page] Folder Deleted',

  DocumentsFilterChanged = '[PolicyDetails Page] Documents Filters Changed',
  DocumentsViewMore = '[PolicyDetails Page] View More Documents',
  DocumentsViewTypeChanged = '[PolicyDetails Page] Documents View Type Changed',
  DocumentUpdated = '[PolicyDetails Page] Document Updated',
  DocumentDeleted = '[PolicyDetails Page] Document Deleted',

  Destroyed = '[PolicyDetails Page] Destroyed',

  RequestPolicyCancellationClicked = '[PolicyDetails Page] Request Policy Cancellation Clicked',
  CancelPolicyClicked = '[PolicyDetails Page] Cancel Policy Clicked',

  ViewEnquiriesClicked = '[PolicyDetails Page] View Enquiries Clicked',
}

export const PolicyDetailsActions = {
  init: createAction(PolicyDetailsActionTypes.Init),

  deleted: createAction(
    PolicyDetailsActionTypes.Deleted,
    props<{ id: number }>()
  ),

  restored: createAction(
    PolicyDetailsActionTypes.Restored,
    props<{ id: number }>()
  ),

  documentSelected: createAction(
    PolicyDetailsActionTypes.DocumentSelected,
    props<{ id: number; name: string }>()
  ),

  editPolicyClicked: createAction(
    PolicyDetailsActionTypes.EditPolicyClicked,
    props<{ policyId: number }>()
  ),

  uploadDocumentsClicked: createAction(
    PolicyDetailsActionTypes.UploadDocumentsClicked
  ),

  filesDropped: createAction(
    PolicyDetailsActionTypes.FilesDropped,
    props<{ files: File[] }>()
  ),

  documentsFilterChanged: createAction(
    PolicyDetailsActionTypes.DocumentsFilterChanged,
    props<{ filter: DocumentFilterValues }>()
  ),

  documentsViewMore: createAction(PolicyDetailsActionTypes.DocumentsViewMore),

  documentsViewTypeChanged: createAction(
    PolicyDetailsActionTypes.DocumentsViewTypeChanged,
    props<{ viewType: string }>()
  ),

  documentUpdated: createAction(
    PolicyDetailsActionTypes.DocumentUpdated,
    props<{ document: Document }>()
  ),

  documentDeleted: createAction(
    PolicyDetailsActionTypes.DocumentDeleted,
    props<{ id: number }>()
  ),

  resetFilter: createAction(PolicyDetailsActionTypes.ResetFilters),

  folderCreated: createAction(
    PolicyDetailsActionTypes.FolderCreated,
    props<{ folderName: string; parentFolderId: number }>()
  ),

  folderEditted: createAction(
    PolicyDetailsActionTypes.FolderEditted,
    props<{ folder: Folder }>()
  ),

  folderDeleted: createAction(
    PolicyDetailsActionTypes.FolderDeleted,
    props<{ id: number }>()
  ),

  destroyed: createAction(PolicyDetailsActionTypes.Destroyed),

  cancelPolicyClicked: createAction(
    PolicyDetailsActionTypes.CancelPolicyClicked
  ),

  requestPolicyCancellationClicked: createAction(
    PolicyDetailsActionTypes.RequestPolicyCancellationClicked,
    props<{ policyId: number; policyName: string }>()
  ),

  viewEnquiriesClicked: createAction(
    PolicyDetailsActionTypes.ViewEnquiriesClicked
  ),
};
